import ApiService from './api.service';
import { DoctorDTO } from '@/models/DoctorDTO';
import i18n from '@/plugins/i18n';

export default class DoctorService {
  /**
   * Get a DoctorDTO object corresponding to the provided doctor ID
   * @param {number} docId The doctor ID
   * @returns {DoctorDTO} a DoctorDTO object
   */
  public static async getDoctor(docId: number): Promise<DoctorDTO> {
    return await ApiService.get(`${process.env.VUE_APP_PUBLIC_ROOT_API}/doctors/${docId}`)
      .then((response: any) => {
        return response.data as DoctorDTO;
      });
  }

  /**
   * Get doctors
   *
   * @returns {DoctorDTO[]} a list of LocalityDTO object
   */
  public static async fetchDoctors(): Promise<DoctorDTO[]> {
    return await ApiService.get(`${process.env.VUE_APP_PUBLIC_ROOT_API}/doctors`)
      .then((response: any) => {
        const doctorList: DoctorDTO[] = [];
        const noDoctorEntry = {
          doctorId: -1,
          doctorName: i18n.t('questionnaire.doctor.noDoctor'),
          doctorAddress: '',
          doctorAddressId: -1
        } as DoctorDTO;

        doctorList.push(noDoctorEntry);

        return doctorList.concat(response.data);
      });
  }
}
